import { Box, Flex } from '@chakra-ui/react';

import { TextSemiBold } from 'UiKit/typography';
import { reportTabText } from 'Const/report/text';
import ButtonSolid from 'UiKit/button/buttonSolid';
import { ExportIcon } from 'Asset/icon';
import { reportHeadText } from 'Const/report/text';
import useGetExportReport from 'Domain/report/useExportGetReport';

import { useReportState } from 'View/report/state';
import scrollTableToLeft from 'Helper/scrollTableToLeft';

import styles from './styles.module.css';

const Tab = () => {
  const { state, updateState, resetFilterState } = useReportState();
  const { mutate: onExportReport } = useGetExportReport();

  const updateSelectedTab = (selectedTab) => {
    scrollTableToLeft();
    updateState({ selectedTab });
    resetFilterState();
  };

  return (
    <Flex className={styles['tab__container']}>
      <Flex className={styles['tab__container--left']}>
        <Box className={`${styles['tab__item']} ${state?.selectedTab === 'brand' && styles['tab__item--actived']}`} onClick={() => updateSelectedTab('brand')}>
          <TextSemiBold className={styles['tab__text']}>{reportTabText?.achievementBrandText}</TextSemiBold>
        </Box>

        <Box className={`${styles['tab__item']} ${state?.selectedTab === 'host' && styles['tab__item--actived']}`} onClick={() => updateSelectedTab('host')}>
          <TextSemiBold className={styles['tab__text']}>{reportTabText?.achievementHostText}</TextSemiBold>
        </Box>

        <Box
          className={`${styles['tab__item']} ${state?.selectedTab === 'accountPlatform' && styles['tab__item--actived']}`}
          onClick={() => updateSelectedTab('accountPlatform')}
        >
          <TextSemiBold className={styles['tab__text']}>{reportTabText?.achievementAccountPlatformText}</TextSemiBold>
        </Box>

        <Box
          className={`${styles['tab__item']} ${state?.selectedTab === 'session' && styles['tab__item--actived']}`}
          onClick={() => updateSelectedTab('session')}
        >
          <TextSemiBold className={styles['tab__text']}>{reportTabText?.sessionText}</TextSemiBold>
        </Box>
      </Flex>

      <Flex className={styles['tab__container--right']}>
        <ButtonSolid
          type="button"
          className={styles['export__button']}
          height="34px"
          leftIcon={<ExportIcon width="12px" height="12px" color="var(--color-semantic-white)" />}
          onClick={() => onExportReport(onExportReport)}
        >
          {reportHeadText.exportText}
        </ButtonSolid>
      </Flex>
    </Flex>
  );
};

export default Tab;
